exports.TELEGRAM_CHANEL_LINK= "https://t.me/gun_trader_channel";
// exports.TELEGRAM_GROUP_LINK = "https://t.me/gun_trader_group";
exports.TWITTER_LINK = 'https://x.com/gun_trader_bot';
exports.GITBOOK_LINK = '#';